import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { SocialMediaSliderProps } from "./types";
import {
    PropertyDefinition,
    PropertyMappingType,
} from "app/library/layout-builder";

import { SlideshowDefinition } from 'components/cms/definitions';

export class SocialMediaSliderDefinitions extends CmsReactComponent<SocialMediaSliderProps> {
    static schemaName = "social-media-slider";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "settings",
            text: "Ayarlar",
            description: "Slayt Ayarları",
            mapping: {
                type: PropertyMappingType.ParentObject,
                children: SlideshowDefinition,
            },
        },
    ];
}
